// Mexico, Honduras, El Salvador, Guatemala, Bolivia, Costa Rica y Republica Dominicana

export enum TimeZone {
  GMT_3 = 'GMT-3',
  GMT_4 = 'GMT-4',
  GMT_5 = 'GMT-5',
  GMT_6 = 'GMT-6',
  GMT_7 = 'GMT-7',
  GMT_8 = 'GMT-8',
}

export const TIME_ZONES = [
  TimeZone.GMT_3,
  TimeZone.GMT_4,
  TimeZone.GMT_5,
  TimeZone.GMT_6,
  TimeZone.GMT_7,
  TimeZone.GMT_8
]

export interface ITimeZoneOption {
  label: string;
  value: TimeZone;
}

const timezones: ITimeZoneOption[] = [
  {
    value: TimeZone.GMT_4,
    label: 'GMT-3 - Chile, Argentina. ',
  },
  {
    value: TimeZone.GMT_4,
    label: 'GMT-4 - Bolivia, República Dominicana. ',
  },
  {
    value: TimeZone.GMT_5,
    label: 'GMT-5 - Colombia, Mexico (Cancún), Panamá, Ecuador, Perú. ',
  },
  {
    value: TimeZone.GMT_6,
    label: 'GMT-6 - Mexico (CDMX), Honduras, El Salvador, Guatemala, Costa Rica, Nicaragua. ',
  },
  {
    value: TimeZone.GMT_7,
    label: 'GMT-7 - Mexico (Hermosillo). ',
  },
  {
    value: TimeZone.GMT_8,
    label: 'GMT-8 - Mexico (Tijuana). ',
  },
]

export const TIME_ZONES_WITH_OFFSET = {
  [TimeZone.GMT_3]: "-03:00",
  [TimeZone.GMT_4]: "-04:00",
  [TimeZone.GMT_5]: "-05:00",
  [TimeZone.GMT_6]: "-06:00",
  [TimeZone.GMT_7]: "-07:00",
  [TimeZone.GMT_8]: "-08:00",
}

export default timezones
